import classNames from 'classnames';
import React, { ReactChild, useState } from 'react';

import { IOneImage } from './Common';
import StatusTag from '../Tag/StatusTag';
import LazyLoadColumn from './LazyLoadColumn';
import { GalleryCheck } from './GalleryCheck';
import useGalleryCheck from './useGalleryCheck';
import { IGalleryStatus } from '../../global.d';

interface IColumnWaterfall extends IOneImage {
  afterChild?: ReactChild;
  lazy?: boolean;
  width?: number;
  height?: number;
}
const ColumnWaterfall = (props: IColumnWaterfall) => {
  const { checkShow, index } = useGalleryCheck(props);
  const [loaded, setLoaded] = useState(false);

  const { width, height } = props;

  const realPaddingBottom =
    Number(width) && Number(height) && width && height
      ? ((height * 100) / width).toFixed(2) + '%'
      : '';

  const paddingBottom = loaded
    ? 0
    : !!realPaddingBottom
    ? realPaddingBottom
    : props.isVertical
    ? '150%'
    : '66.66%';
  return (
    <div
      className={classNames('column column2 columnwaterfall', {
        vertical: props.isVertical,
      })}
      onClick={props.onClick}
    >
      <LazyLoadColumn lazy={props.lazy}>
        <div
          className="img-wrapper column-waterfall-img-wrapper"
          style={{
            paddingBottom,
          }}
          data-id={props.id}
          data-index={
            props && typeof props.index != 'undefined' ? props.index + 1 : 0
          }
        >
          <img
            src={props.src}
            style={{ position: loaded ? 'inherit' : 'absolute' }}
            onLoad={() => {
              setLoaded(true);
            }}
            loading={`lazy`}
            className="src"
            data-index={
              props && typeof props.index != 'undefined'
                ? props.index * 1 + 1
                : 0
            }
          />
          {checkShow ? <GalleryCheck index={index} /> : null}
          {props.isPayed ? (
            <StatusTag
              status={IGalleryStatus.payed}
              className={'status payed-status'}
              fontSize={12}
            />
          ) : null}
        </div>
      </LazyLoadColumn>
      {props.afterChild}
    </div>
  );
};

export default ColumnWaterfall;
